import axios from "axios";

export const comerciosService = {
  async comercioxVarios(e) {
    try {
      let response = await axios.post("https://wsrfa.sannicolasciudad.gob.ar/consultas/comercioxVarios.php", {
        data: {
          bsq: 1,
          ...e
        }
      });

      // bsq: bandera en búsqueda. Cualquier valor (preferentemente 1.)
      // inm: número de inmueble. Numérico    
      // cc:  CUIT/CUIL  sin guiones u otros separadores. Numérico.    
      // contrib: nombre de contribuyentes. Cantidad de caracteres: 3 o +    
      // fant: nombre de fantasía de comercio. Cantidad de caracteres: 3 o +    
      // calle: calle de dirección de  comercio. Cantidad de caracteres: 3 o +    
      // nro: altura de dirección de  comercio. Numérico

      return response;
    }
    catch (err) {
      return err.message;
    }
  }
};